import random from 'seedrandom';

export function shuffle(a, rng = Math.random) {
  const b = [...a];
  for (let i = b.length - 1; i > 0; i -= 1) {
    const j = Math.floor(rng() * (i + 1));
    [b[i], b[j]] = [b[j], b[i]];
  }
  return b;
}

export function shuffleSeeded(a, seed, skipRolls = 0) {
  const rng = random(seed);
  for (let x = 0; x < skipRolls; x += 1) {
    rng();
  }
  return shuffle(a, rng);
}

export default {
  methods: {
    getSlug(name) {
      return name.trim().toLowerCase().replace(/(\s)+/g, '-');
    },
    getUsedPhrases(game, usedPhrases = []) {
      const currentUsedPhrases = [...usedPhrases];
      game.rounds.forEach(({ phrases }) => {
        phrases.forEach(({ phraseId }) => {
          currentUsedPhrases.push(Number(phraseId));
        });
      });
      if (game.previous == null) {
        return currentUsedPhrases;
      }
      return this.getUsedPhrases(this.$store.state.games.list[game.previous], currentUsedPhrases);
    },
    getNewRoundForGame(currentGame) {
      if (currentGame.players.length === currentGame.rounds.length) {
        return null;
      }
      const newRound = {
        finished: false,
        player: null,
        phrases: [],
      };
      const game = { ...currentGame };

      const usedPlayers = game.rounds.map(round => round.player);
      ([newRound.player] = shuffle(game.players.filter(player => !usedPlayers.includes(player))));

      const usedPhrases = this.getUsedPhrases(game);
      let usablePhrases = this.$store.state.phrases
        .map((phrase, phraseId) => phraseId)
        .filter(phraseId => !usedPhrases.includes(phraseId));
      if (usablePhrases < 3) {
        usablePhrases = this.$store.state.phrases.map((phrase, phraseId) => phraseId);
      }
      usablePhrases = shuffle(usablePhrases);
      for (let x = 0; x < 3; x += 1) {
        newRound.phrases.push({
          phraseId: usablePhrases[x],
        });
      }
      return newRound;
    },
  },
};
